import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';

type SectionProps = {
	children?: React.ReactNode;
	title?: string;
	subtitle?: string;
	required?: boolean;
	isCentered?: boolean;
}
const Section: React.FunctionComponent<SectionProps> = ({children, title, subtitle, required, isCentered}) => (
	<div className={classNames(
		styles.section,
		isCentered && styles.isCentered
	)}>
		{
			Boolean(title || subtitle) &&
				<div className={styles.title}>
					{
						Boolean(title) &&
							[title, required && '*']
								.filter(i => i)
								.join(' ')
					}
					{
						Boolean(subtitle) &&
							<div className={styles.subtitle}>
								{subtitle}
							</div>
					}
				</div>
		}
		{children}
	</div>
);

export default Section;
